import { useMemo } from "react";
import {
  ErrorMessage,
  LoadingData,
  SelectForm as Select,
  InputForm as Input,
  MainButton,
} from "../../ui";
import {
  usePatientSurgeryStore,
  useFormEventStore,
  useSelectOptionsStore,
} from "../../hooks";
import { IPS_IDS, PROCEDURE_IDS } from "../../data";

const configRender = {
  [`${PROCEDURE_IDS.CORE}-${IPS_IDS.SOGAMOSO}`]: {
    showSearchButton: false,
  },
};

export const AssessmentFilterForm = ({ propsForm }) => {
  const {
    // Props
    formState,
    formValidation,
    showErrorMessage,
    messageText,
    validateForm,
    matchedConfig,

    // Methods
    onInputChange,
    handleSubmitFilterForm,
  } = propsForm;

  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const {
    // Props
    isLoading,
  } = useFormEventStore();

  const {
    // Props
    doctors,
  } = useSelectOptionsStore();

  const { patient, procedure } = patientSurgery.data;
  const { ips } = patient.user;
  const { id: procedureParentId } = procedure.procedure;
  const { id: ipsId, name: ipsName } = ips;

  // States ------------------------------------------------//
  const renderConfig = useMemo(() => {
    return configRender[`${procedureParentId}-${ipsId}`] || null;
  }, [procedureParentId, ipsId]);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  // useEffect(() => {
  //   console.log("formState", formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log("formValidation", formValidation);
  // }, [formValidation]);

  return (
    <div className="card border">
      <div className="card-body">
        <div className="row gy-3">
          <div className="col-12">
            <h5 className="mb-0">Agenda tu sesión virtual</h5>
          </div>
          <div className="col-12">
            <Input
              label={`IPS`}
              name="ips"
              value={`${ipsName}`}
              onInputChange={() => {}}
              disabled={true}
            />
          </div>
          <div className="col-12">
            <Select
              label={"Doctor y sede"}
              options={doctors.data}
              labelKey={"name"}
              validation={formValidation.doctorHeadquarterScheduleIdValid}
              submit={validateForm}
              name={"doctorHeadquarterScheduleId"}
              value={formState.doctorHeadquarterScheduleId}
              onInputChange={onInputChange}
              disabled={!!matchedConfig}
            />
          </div>
          {renderConfig?.showSearchButton !== false && (
            <div className="col-12">
              <MainButton
                type="button"
                onClick={handleSubmitFilterForm}
                disabled={isLoading || doctors.isLoading}
              >
                Buscar
              </MainButton>
            </div>
          )}

          {/* Mensajes */}
          {(doctors.isLoading || isLoading) && (
            <div className="col-12">
              <LoadingData />
            </div>
          )}

          {showErrorMessage && (
            <div className="col-12">
              <ErrorMessage>{messageText}</ErrorMessage>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
